import React, { useEffect, useRef, useState } from "react";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import { useHistory, useParams } from "react-router-dom";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import MultiRangeSlider from "../../Components/MultiRangeSlider";
const Wastes = (params) => {
  const history = useHistory();
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div class="row mx-0">
              <div class="shadowclass top_filters orderpayy mt-4 mb-3">
                <h4 class="event-alert py-0 my-2">Filters </h4>
                <div className="row mx-0">
                  <div class="col-lg-4 col-md-6 pl0 px-0 px-sm-3">
                    <div class="calander d-flex align-items-center">
                      <div class="datePicker pading_right">
                        <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                          <input
                            name="from_date"
                            class=" "
                            required="required"
                            type="text"
                            id=""
                            value="2022-05-01"
                          />
                          <span class="add-on">
                            <i class="fa fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                      <div class="datePicker pading_lect">
                        <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                          <input
                            name="to_date"
                            class=" "
                            required="required"
                            type="text"
                            id=""
                            value="2022-05-13"
                          />
                          <span class="add-on">
                            <i class="fa fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-6 timing-duration pt-3 pt-sm-0">
                  <MultiRangeSlider
                      min={0}
                      max={1000}
                      onChange={({ min, max }) =>
                        console.log(`min = ${min}, max = ${max}`)
                      }
                    />
                  </div>
                  <div class="selecters col-lg-5 col-md-10 pl-md-0 row mx-0 justify-content-between pt-3 pt-lg-0">
                    <div class="select-div col px-1 pl-md-0">
                      <div class="input select">
                        <select
                          name="waste_group"
                          class="csutom_select"
                          id="WasteWasteGroup"
                        >
                          <option value="">Waste Group</option>
                          <option value="28">Food R&amp;D</option>
                        </select>
                      </div>
                    </div>
                    <div class="select-div col px-1">
                      <div class="input select">
                        <select
                          name="waste_type"
                          class="csutom_select"
                          id="WasteWasteType"
                        >
                          <option value="">Waste Type</option>
                          <option value="1">Waste Cost</option>
                          <option value="2">Waste Return</option>
                        </select>
                      </div>
                    </div>
                    <div class="select-div col px-1">
                      <div class="input select">
                        <select
                          name="supplier"
                          class="csutom_select"
                          id="WasteSupplier"
                        >
                          <option value="">Supplier</option>
                          <option value="6178">6 Drunk Men Pte Ltd</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-1 col px-0 pt-3 pt-lg-0">
                    <button class="btn btn_btnblue" type="submit">
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-0">
              <div class="shadowclass">
                <div class="col-12">
                  <div class="counts">
                    <h4 class="event-alert">Submitted Sheets</h4>
                    <div class="row justify-content-between align-items-center w-100 mx-0">
                      <div class="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                        <div class="search-box">
                          <form
                            action="/productions"
                            id="MenuItemIndexForm"
                            method="get"
                            accept-charset="utf-8"
                          >
                            <input
                              name="keyword"
                              placeholder="Search"
                              type="text"
                              id="MenuItemKeyword"
                            />
                            <input type="submit" />
                          </form>
                        </div>
                      </div>
                    </div>

                    <div className="shadowclass mt-0 p-0">
                      <div className="table-responsive">
                        <table className="checklist-table remove-space inventory_table">
                          <thead>
                            <tr>
                              <th class="min-wd-150">Account</th>
                              <th>ID</th>
                              <th>Waste Type</th>
                              <th>Waste Group/Supplier</th>
                              <th># Of Waste Items</th>
                              <th>Total</th>
                              <th className="min-wd-200">Created</th>
                              <th className="action-td">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <strong>Boat Quay Pilot</strong>
                              </td>
                              <td>130</td>
                              <td>Waste Return </td>
                              <td>Ngoh Song Trader</td>

                              <td>1</td>
                              <td>$2.9000 </td>
                              <td>2022/05/12 13:14pm </td>
                              <td class="action-td">
                                <div className="d-flex">
                                  <a href="#_" class="circle_icon">
                                    <i class="iconSprites eye-icon">
                                      <div class="tooltip-sm"> View </div>
                                    </i>
                                  </a>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Wastes;
